module.exports = __webpack_public_path__ + "static/media/mn.9ebe47eb.svg";